import { mivoDb } from "@/domains/offline/db/mivoDb";
import type { PatientBundleRecord, PatientListRow, SessionRow } from "@/domains/offline/db/schema";
import { normalizeApiPath } from "@/domains/offline/guards/offlineCapability";

export async function readCachedGet(url: string, params?: Record<string, unknown>): Promise<unknown | null> {
  const path = normalizeApiPath(url);

  if (path === "/patients") {
    const rows = await mivoDb.patients.toArray();
    return rows.length > 0 ? rows : null;
  }

  if (path === "/sessions") {
    const rows = await mivoDb.sessions.toArray();
    return rows.length > 0 ? rows : null;
  }

  return null;
}

export async function getCachedPatients(): Promise<PatientListRow[]> {
  return mivoDb.patients.toArray();
}

export async function getCachedSessions(): Promise<SessionRow[]> {
  return mivoDb.sessions.toArray();
}

export async function getCachedPatientBundle(patientId: string): Promise<PatientBundleRecord | undefined> {
  void patientId;
  return undefined;
}
